import { makeStyles } from 'tss-react/mui';

/**
 * Pill-shaped 52px-tall primary action button shared by every mobile signing
 * sheet (Next, Adopt & Sign, Sign Here / Clear Signature, Continue Reviewing,
 * Finish Signing). Apply via AlineButton's `buttonClassName` so the styles
 * land on the underlying `<button>` rather than its wrapper div.
 */
export const useMobileSheetActionButtonStyles = makeStyles()(theme => ({
  button: {
    borderRadius: 999,
    fontSize: 16,
    fontWeight: 600,
    /**
     * AlineButton's root locks height to 32px; unlock so the full-width pill
     * can hit a comfortable tap target.
     */
    height: 'auto',
    minHeight: 52,
    padding: theme.spacing(1.5, 3),
  },
}));
